// extracted by mini-css-extract-plugin
module.exports = {"section-contents":"SectionContents_section-contents__2WXJ0"};